import Divider from 'shared/components/molecules/Divider/Divider';

export default Divider;
